import { CheckSingleIcon } from '@grupoboticario/flora-react-icons';
import { ButtonGhost, Card, Text } from 'ui/components/primitives';
import { styled, theme } from 'ui/theme';

export const Boleto = {
  Button: styled(ButtonGhost)`
    align-items: center;
    display: flex;
    gap: ${theme.space[2]};
    justify-content: center;
    margin-top: ${theme.space[6]};
  `,

  Card: styled(Card)`
    margin-bottom: ${theme.space[8]};
    margin-top: ${theme.space[3]};

    span {
      display: block;
    }
  `,

  OrderInfo: styled('div')`
    display: grid;
    grid-gap: ${theme.space[1]};
  `,

  SuccessIcon: styled(CheckSingleIcon)`
    color: ${theme.colors.build.brand2};
    margin-bottom: ${theme.space[2]};
  `,

  SuccessMsg: styled('div')`
    align-items: center;
    display: flex;
    flex-flow: column;
    gap: ${theme.space[2]};
  `,

  SuccessText: styled(Text)`
    display: block;
    text-align: center;
  `,
};
